import { Avatar, Stack, Typography } from '@mui/material';
import { SuppliersContext } from 'Context/SuppliersContext';
import { useIsDesktop } from 'Hooks';
import { useContext } from 'react';

export interface ICategory {
  image: string;
  text: string;
}

export const Category = ({ image, text }: ICategory) => {
  const isDesktop = useIsDesktop();
  const { setStepIndex } = useContext(SuppliersContext);

  return (
    <Stack
      justifyContent='center'
      alignItems='center'
      gap={isDesktop ? '12px' : '6px'}
      sx={{
        p: isDesktop ? '20px 64px' : '12px 16px',
        width: 'fit-content',
        bgcolor: '#FFF',
        borderRadius: '10px',
        border: '1px solid',
        borderColor: 'primary.shade_200',
        ':hover': isDesktop
          ? {
              cursor: 'pointer',
              bgcolor: 'purple2.shade_200',
              borderColor: 'purple2.shade_400',
            }
          : {
              borderColor: 'primary.main',
            },
      }}
      onClick={() => setStepIndex(1)}
    >
      <Avatar alt='' src={image} />
      <Typography variant={isDesktop ? 'body1' : 'h6'}>{text}</Typography>
    </Stack>
  );
};
